<script>
export default {
  components: {},
  props: {
    exercises: {
      type: Array,
      required: true,
      default: null,
    },
    circuit: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <ul class="list-circuit-exercises">
    <li class="list-circuit-exercises-item">
      <div class="list-circuit-exercises-header">
        <h3>{{ circuit.label }}</h3>
        <h3>x{{ circuit.circuitReps }}</h3>
      </div>
      <BaseListMinimal :items="exercises" :showThumbnail="true" type="lite" />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.list-circuit-exercises {
  .list-circuit-exercises-item {
    margin-bottom: 5rem;
  }

  .list-circuit-exercises-header {
    border-bottom: 1px solid $color-medium-gray;
    display: flex;
    justify-content: space-between;
    padding-bottom: 1.1rem;
  }
}
</style>
